import { Controller } from "stimulus"
import Rellax from "rellax"

export default class extends Controller {
  initialize() {
	// var rellax = new Rellax('.rellax', {
	// 	wrapper: '.home-pillars-elements'
	// })
  }
}